var _path, _text;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgRequireLogin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 33.55 35.62"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 25a7.1 7.1 0 011.13-2.94 2.76 2.76 0 011.09-.68c1.26-.5 2.56-.9 3.81-1.42a20 20 0 002.18-1.19c.11-.06.26-.17.27-.26a7.27 7.27 0 000-2.59 6.93 6.93 0 01-.71-2.4l-.14.09a3.89 3.89 0 01-.57-.84 8.44 8.44 0 01-.37-1.58c-.06-.42-.14-.9.46-1a10.4 10.4 0 010-4.51 3.21 3.21 0 011.62-2.2 13 13 0 012.07-1 2.27 2.27 0 01.9 0 13.77 13.77 0 011.71.21c.56.11 1.13.26 1.32.9l.85-.06c.1.17.13.35.24.4a1.78 1.78 0 01.93 1.5 14.8 14.8 0 01-.23 4.74.73.73 0 01.5.9.89.89 0 01-.08.17c-.31.76 0 1.8-1.05 2.39a6 6 0 01-.77 2.4 4.16 4.16 0 000 2.24c.05.33.48.66.82.86a15.89 15.89 0 002 .94c1.33.53 2.69 1 4 1.55a2.08 2.08 0 011 1 23.86 23.86 0 01.71 2.38z"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    transform: "translate(15.82 27.2)",
    fontSize: 32,
    fontFamily: "Gilroy-Bold",
    fontWeight: 700
  }, "+")));
}

export default SvgRequireLogin;